<template>
  <div class="page">
    <div class="mobile-header">
      <i class="el-icon-close close" @click="closed"></i>
      <div class="mobile-header-title">菲龙网充充充</div>
    </div>

    <div class="container">
      <div class="mobile-content">
      <div class="mobile-content">
        <img :src="qrcode" width="300px">
        <div class="tip" v-if="msg != ''">{{msg}}</div>
        <div class="wechat_title" >
          <img src="../assets/wechat.png" width="25px" /><span >请使用微信扫码登录</span>
        </div>
      </div>
      </div>
      <div class="copyRight">
        © 2013-2022 FLWCCC Inc.
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'login',
    components: {
    },
    data() {
      return {
        msg: '',
        qrcode: '',
        sync_id: 0,
        task: null,
      }
    },
    mounted() {
      if (localStorage.getItem('auth_token')) {
        this.$router.push('/mine');
      } else {
        this.getQrcode();
      }
    },
    methods: {
      closed() {
        this.$router.push('/');
      },
      getQrcode() {
        clearInterval(this.task);
        this.$api
          .request('Wx/qrcode')
          .then(({ data, msg }) => {
            this.qrcode = data.qrcode;
            this.sync_id = data.sync_id;
            this.task = setInterval(() => {
              this.check();
            }, 2000);
          })
          .catch(error => {
            this.getQrcode();
            this.$message({
              message: "初始化失败！",
              type: "warning"
            })
          });
      },
      check() {
        this.$api
          .request('Wx/check', {sync_id: this.sync_id})
          .then(({ data, msg }) => {
            if (data.refresh) {
              this.msg = data.msg;
              this.getQrcode();
            } else {
              if (data.code) {
                this.login(data.code);
              }
            }
          })
          .catch(error => {
          });
      },
      login(code) {
        clearInterval(this.task);
         this.$api
           .request('Wx/grantLogin', {code: code})
           .then(({ data, msg }) => {
             this.$message({
               message: "登录成功！",
               type: "success"
             })
             this.$router.push('/mine');
           })
           .catch(error => {
             this.getQrcode();
             this.$message({
               message: "登录失败",
               type: "error"
             })
           });
      },
    }
  }
</script>


<style scoped lang="less">
  /deep/ .el-select .el-input {
    width: 80px;
  }

  /deep/ .el-input-group__prepend {
    border: none;
    position: relative;
    background-color: transparent;

    &::after {
      content: "";
      width: 1px;
      height: 20px;
      border-left: 1px solid #ebebeb;
      position: absolute;
      right: 0;

    }
  }

  /deep/ .el-input__inner {
    border: none;
  }
 .container .mobile-content .mobile-input .msg-wrap .msg{
    width: 100%!important;
  }

  * {
    box-sizing: border-box;
  }

  .page {
    z-index: 2;
    box-sizing: border-box;
    width: 100%;

    .mobile-header {
      background-color: #b22830;
      color: #FFFFFF;
      padding: 20px 15px;

      &-title {
        font-size: 33px;
      }

      &-desc {
        font-size: 20px;
      }
    }
  }

  .container {

    width: 100%;

    .mobile-content {
      font-size: 14px;
      padding: 20px 15px;
      text-align: center;
      position: relative;

      .mobile-input {

        .mobile-wrap,
        .msg-wrap {
          border-bottom: 1px solid #ebebeb;
        }

        .msg-wrap {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .msg {
            width: 200px;
          }

          // padding-right: 100px;
        }
      }
    }

    .btn-wrap {
      .btn.btn-gradient {
        width: 100%;
      }
    }

    .mar-top-10 {
      margin-top: 10px;
    }

    .mar-top-20 {
      margin-top: 20px;
    }

    .flex-center {}

    .title {
      color: #8590a6;
      font-size: 16px;
      text-align: left;
    }

    .copyRight {
      font-size: 14px;
      position: absolute;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      flex-direction: column;
      left: 50%;
      transform: translateX(-50%);
      bottom: 40px;
      color: #8590a6;

    }

  }

  .el-icon-close.close {
    font-size: 24px;
    position: absolute;
    right: 10px;
    top: 10px;

  }

  #captcha_register {
    margin-top: 10px;
    text-align: center;
    width: 100%;
  }

  .wechat_title img{
    vertical-align: middle;
  }

  .wechat_title span{
    vertical-align: middle;
    font-size: 16px;
  }

  .tip {
    color: orangered;
  }

</style>



// WEBPACK FOOTER //
// src/page/login.vue